import * as Sentry from "@sentry/vue";
import { isOfflineFailure } from "@/utils/network";

export const reportDeviceDataError = (
  error,
  { risk, table = null, keys = [] }
) => {
  if (isOfflineFailure(error)) return;
  Sentry.captureException(error, {
    tags: { device_data: risk, device_table: table ?? "none" },
    contexts: { device_data: { risk, table, keys } },
    fingerprint: ["device-data", risk, table ?? "none", error?.name ?? "Error"],
  });
};
